<script>
import {defineComponent} from 'vue'
import axios from "axios";

export default defineComponent({
  name: "app-onlajnovka-students",
  data() {
    return {
      students: [],
      semesters: [],
      current_semester: null,
      current_semester_id: null,
    }
  },
  mounted() {
    this.loadSemesters();


  },

  methods: {
    loadSemesters(){
      axios.get('/onlajnovka/semesters.json').then((response)=>{
        this.semesters = response.data.items
        this.current_semester    = response.data.current
        this.current_semester_id = this.current_semester ? this.current_semester.id : (this.semesters.length>0 ? this.semesters[0].id : null)
        this.loadStudents();

      })

    },
    loadStudents(){
      axios.get('/onlajnovka/students.json', {params: {semester_id: this.current_semester_id}}).then(response => {
        this.students = response.data.items;
      }).catch(error => {
        console.error("Error loading students:", error);
      });
    },

    day_name(day) {
      const days = ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'];
      return days[day];
    }


  }

})
</script>

<template>

  <h2 class="my-2">
    Studenti zapsaní do onlajnovky
  </h2>

  <div class="card card-body index p-0">

    <div class="row">
      <div class="col-md-6">
        <select v-model="current_semester_id" class="form-control w-auto" @change="loadStudents">
          <option v-for="semester in semesters" :key="semester.id" :value="semester.id">
            {{ semester.name }}
          </option>
        </select>
      </div>
    </div>

      <table class="table table-striped">
        <tr v-for="student in students" :key="student.id">
          <td>{{ student.name }} {{ student.surname }}</td>
          <td>{{ student.email }}</td>
          <td>{{ student.tel }}</td>
          <td>
            <div v-for="l in student.lessons">
              <span class="">{{ l.level_name }} / {{ day_name(l.day) }} {{ l.hour }}:00</span>
            </div>

          </td>
        </tr>
      </table>

  </div>
</template>

<style scoped>

</style>